export enum FRONT_COLUMN_TABLE_ENUM {
	name = "name",
	logo = "Logo",
	availability = "availability",
	box_folder_id = "box_folder_id",
	box_user_group_id = "box_user_group_id",
}

export const FRONT_COLUMNS = {
	name: "name",
	logo: "file_mkspamz4",
	availability: "boolean_mkswtq0w",
	boxFolderId: "text_mkwkaazy",
	boxUserGroupId: "text_mkwj8g1f",
	featureFlag: "featureflag",
	sso: "ssotype",
} as const;

export type ClientInfos = {
	logo: string;
	boxRootFolderId: string;
	boxGroupId: string;
	disabledFeatures: string[];
	customNavigation: { name: string; url: string; iconName: string }[];
};

export enum FEATURE_FLAGS {
	analytics = "analytics",
	files = "files",
	createOperation = "createoperations",
}

export const LS_CLIENT_INFOS = "@onevision-client-infos";

export const FILE_SIZE_UPLOAD_LIMIT = 500000000; /* Monday api limit */
